/* istanbul ignore file */
/** This is a placeholder, not real render in dom */
var TreeNode = function TreeNode() {
  return null;
};
TreeNode.inheritAttrs = false;
TreeNode.displayName = 'ATreeSelectNode';
TreeNode.isTreeSelectNode = true;
export default TreeNode;